<template>
  <div id="mtnDashboardApp" class="mtn-dashboard-container" :class="`mtn-dashboard-${resortSlug}`">
    <MobileAlert :alert="snow_report.Alert" :alertBtn="snow_report.StormRadar" :alertBtnText="snow_report.StormRadarButtonText" />
    <MobileNavigation />

    <router-view/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MobileAlert from '@/components/MobileAlert.vue';
import MobileNavigation from '@/components/MobileNavigation.vue';
import { resortConfig } from '@/store/data/resort.config';

export default {
  components: {
    MobileNavigation,
    MobileAlert,
  },

  data() {
    return {
      resort: resortConfig,
    };
  },

  computed: {
    ...mapState(['snow_report', 'resortSlug']),
  },

  methods: mapActions([
    'getResortInfo',
    'getResortLifts',
    'getWebcams',
    'getWeather',
  ]),

  created() {
    // TODO: create a "bootstrap" action for these:
    // Don't fetch all of this data for snowfall chart only route
    if (this.$route.name !== 'snowfallChart') {
      this.getResortInfo();
      this.getResortLifts();
      this.getWebcams();
      this.getWeather();
    }
  },
};
</script>

<style lang="scss">
@import '~@/scss/site';

// This reaches UP into parent container/page and turns off overflow: hidden;
.site-wrapper {
  overflow: visible;
}

#mtnDashboardApp {
  background-color: $body-bg;
  margin-top: -42px;
  overflow: hidden;
}
</style>
